import WarmLeadTemplate from "../../../../components/templates/LeadTemplates/WarmLeadTemplate/WarmLeadTemplate";
const WarmLeads = () => {
  return <WarmLeadTemplate />;
};

export default WarmLeads;
